import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  GroupRelatedGroupsAddFulfilledAction,
  GroupRelatedGroupsRemoveFulfilledAction,
} from '../../domains/groupRelatedGroups/actions.types';
import type { GroupRelatedGroupsLoadAction } from '../../domains/groupRelatedGroupsLoad/actions.types';

import type { GroupRelatedGroups } from './types';

export type GroupRelatedGroupsAction =
  | GroupRelatedGroupsLoadAction
  | GroupRelatedGroupsRemoveFulfilledAction
  | GroupRelatedGroupsAddFulfilledAction;

const initialState: GroupRelatedGroups = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const removeGroupRelationshipFromState = (
  state: GroupRelatedGroups,
  { groupId, edgeId }: GroupRelatedGroupsRemoveFulfilledAction['payload']
): GroupRelatedGroups =>
  update(state, groupId, {
    id: groupId,
    relatedGroups: state.fulfilled.byId[groupId].relatedGroups.filter((edge) => edge.id !== edgeId),
  });

const addGroupRelationshipToState = (
  state: GroupRelatedGroups,
  { groupId, relatedGroupId, edgeId }: GroupRelatedGroupsAddFulfilledAction['payload']
): GroupRelatedGroups => {
  const relatedGroups = state.fulfilled.byId[groupId].relatedGroups;

  const newGroupRelationship = {
    [groupId]: {
      id: groupId,
      relatedGroups: [...relatedGroups, { id: edgeId, nodeId: relatedGroupId }],
    },
  };

  return moveToFulfilled(state, newGroupRelationship);
};

const reducer: Reducer<GroupRelatedGroups, GroupRelatedGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_RELATED_GROUPS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_RELATED_GROUPS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_RELATED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupRelatedGroups);
    case 'GROUP_RELATED_GROUPS.REMOVE_GROUP_FULFILLED':
      return removeGroupRelationshipFromState(state, action.payload);
    case 'GROUP_RELATED_GROUPS.ADD_GROUP_FULFILLED':
      return addGroupRelationshipToState(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
